let botaoHamburguer;
let menuLateral;
let listaDoMenuLateral;
let sobreposicao;
let dispositivoMenorQueTablet;
function gerenciarMenuLateral() {
  botaoHamburguer.classList.toggle('botao-hamburguer_estado-minimizar');
  menuLateral.classList.toggle('menu-lateral_minimizado');
  if (dispositivoMenorQueTablet) {
    sobreposicao.classList.toggle('sobreposicao_ativo');
    sobreposicao.classList.toggle('sobreposicao_menu-lateral');
  }
}
function gravarOEstadoNoLocalStorage() {
  if (localStorage.estadoDoMenuLateral !== 'aberto') {
    localStorage.estadoDoMenuLateral = 'aberto';
  } else localStorage.estadoDoMenuLateral = 'fechado';
}
function retirarScrollDoBody() {
  document.body.classList.remove('pagina_sem-scroll');
}
function gerenciarMenuLateralEGravarNoStorage() {
  gerenciarMenuLateral();
  gravarOEstadoNoLocalStorage();
}
function mostrarOMenuNoEstadoQueOUsuarioDeixouPelaUltimaVez() {
  if (localStorage.estadoDoMenuLateral === 'aberto') {
    gerenciarMenuLateral();
    if (dispositivoMenorQueTablet) gerenciarMenuLateralEGravarNoStorage();
  }
}
function abrirEFecharMenuPeloBotaoHamburguer() {
  botaoHamburguer.onclick = () => {
    gerenciarMenuLateralEGravarNoStorage();
    if (dispositivoMenorQueTablet) document.body.classList.toggle('pagina_sem-scroll');
  };
}
function resetarEstadoDeMenuQuandoMudaOTamanhoDoViewport() {
  window.onresize = () => {
    dispositivoMenorQueTablet = window.innerWidth < 900;
    if (localStorage.estadoDoMenuLateral === 'aberto' && dispositivoMenorQueTablet) {
      gerenciarMenuLateralEGravarNoStorage();
      sobreposicao.classList.remove('sobreposicao_ativo');
    }
  };
}
function fecharAoClicarNoItemDoMenuLateral() {
  listaDoMenuLateral.onclick = () => {
    if (dispositivoMenorQueTablet) {
      gerenciarMenuLateralEGravarNoStorage();
    } else if (localStorage.estadoDoMenuLateral !== 'aberto') {
      menuLateral.classList.add('menu-lateral_minimizado-sem-hover');
      setTimeout(() => {
        menuLateral.classList.remove('menu-lateral_minimizado-sem-hover');
      }, 500);
    }
    retirarScrollDoBody();
  };
}
function fecharAoClicarNaSobreposicao() {
  sobreposicao.onclick = () => {
    if (sobreposicao.classList.contains('sobreposicao_menu-lateral')) {
      gerenciarMenuLateralEGravarNoStorage();
      retirarScrollDoBody();
    }
  };
}
function iniciarGerenciadorDeMenu() {
  botaoHamburguer = document.querySelector('.botao-hamburguer');
  menuLateral = document.querySelector('.menu-lateral');
  listaDoMenuLateral = document.querySelector('.menu-lateral__lista');
  sobreposicao = document.querySelector('.sobreposicao');
  dispositivoMenorQueTablet = window.innerWidth < 900;
  mostrarOMenuNoEstadoQueOUsuarioDeixouPelaUltimaVez();
  resetarEstadoDeMenuQuandoMudaOTamanhoDoViewport();
  abrirEFecharMenuPeloBotaoHamburguer();
  fecharAoClicarNoItemDoMenuLateral();
  fecharAoClicarNaSobreposicao();
}
export default iniciarGerenciadorDeMenu;


// WEBPACK FOOTER //
// ./src/utils/botao-hamburguer.js